import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";

const IDVerification = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    idNumber: "",
    frontId: null,
    backId: null,
  });

  const [errors, setErrors] = useState({
    name: "",
    idNumber: "",
    frontId: "",
    backId: "",
  });

  const handleInputChange = (e) => {

    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors(prevErrors => ({ ...prevErrors, [name]: false }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = "Name on ID card is required";
    if (!formData.idNumber) newErrors.idNumber = "ID card number is required";
    if (!formData.frontId) newErrors.frontId = "Front side of ID card is required";
    if (!formData.backId) newErrors.backId = "Back side of ID card is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const previousformData = location.state;

      previousformData.idCardVerification = {
        name: formData.name,
        idNumber: formData.idNumber,
        frontId:"https://as1.ftcdn.net/v2/jpg/03/66/51/86/1000_F_366518642_U0OHJksfJB1dQGYXExpoAeRIDH8EbWYv.jpg",//formData.frontId,
        backId:"https://as1.ftcdn.net/v2/jpg/03/66/51/86/1000_F_366518642_U0OHJksfJB1dQGYXExpoAeRIDH8EbWYv.jpg"//formData.backId
      };
      console.log(previousformData);

      navigate(route.subscriptionplan, { state: previousformData });
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          
          <div className="login-content">
            <form onSubmit={handleSubmit} style={{ width: '80%' }}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
                </Link>
                <div className="login-userheading">
                <h3>Profile -{">"} Store Address -{">"} ID Verification</h3>

                </div>
                <div className="form-login">
                  <label>Name on ID Card</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      name="name"
                      maxLength={30}
                      value={formData.name}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                    <ImageWithBasePath src="assets/img/icons/user-icon.svg" alt="img" />
                  </div>
                  
                  {errors.name && <p className="text-danger">{errors.name}</p>}
                </div>
                <div className="form-login">
                  <label>ID Card Number</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      maxLength={13}
                      name="idNumber"
                      value={formData.idNumber}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                    <ImageWithBasePath src="assets/img/icons/mail.svg" alt="img" />
                  </div>
                  {errors.idNumber && <p className="text-danger">{errors.idNumber}</p>}
                </div>

                <div className="form-login">
                  <label>Upload Front Side of ID Card</label>
                  <div className="form-addons">
                    <input
                      type="file"
                      name="frontId"
                      onChange={handleFileChange}
                      className="form-control"
                    />
                    {/* <ImageWithBasePath src="assets/img/icons/upload.svg" alt="img" /> */}
                  </div>
                  {errors.frontId && <p className="text-danger">{errors.frontId}</p>}
                </div>

                <div className="form-login">
                  <label>Upload Back Side of ID Card</label>
                  <div className="form-addons">
                    <input
                      type="file"
                      name="backId"
                      onChange={handleFileChange}
                      className="form-control"
                    />
                    {/* <ImageWithBasePath src="assets/img/icons/upload.svg" alt="img" /> */}
                  </div>
                  {errors.backId && <p className="text-danger">{errors.backId}</p>}
                </div>

                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    Next
                  </button>
                </div>

                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>Copyright © 2024 WizzTech. All rights reserved</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDVerification;